export default __webpack_public_path__ + "static/media/rejected_icon.d94d449c.svg";